import { useTranslation } from 'react-i18next';
import './header.less';
import './header-mobile.less';
import ProLanguageSelect from '../../shared/pro-language-select/pro-language-select';
import ProButton from '../../shared/pro-button/pro-button';
import Logo from '../../../assets/proproctor-logo.svg';
import HeadsetIcon from '../../../assets/headset.svg';
import HeadsetIconHover from '../../../assets/headset-hover.svg';
import { langOptions } from '../../../i18n';

export interface HeaderProps {
  hiddenHeaderContent?: boolean;
}

function Header({ hiddenHeaderContent }: HeaderProps) {
    const { t, i18n } = useTranslation();
    const imgElement = document.querySelector('img');
    const imgElementDiv = document.querySelector('.header-contact-support');
    imgElementDiv?.addEventListener('mouseover', () => {

    imgElement!.src = HeadsetIconHover ; // Replace with your new image path
  });
  
  imgElementDiv?.addEventListener('mouseout', () => {
    imgElement!.src = HeadsetIcon; // Reset to original image
  });
  
    return (
        <header className='header'>
            <div className='header-menu'>
                <div className='header-top-buttons'>
                    <div>
                    <nav className='header-contact-support-nav' role='navigation'  aria-label={t('HEADER_CONTACT_SUPPORT_PAGE')} > 
                        <a className='header-contact-support' href={process.env.REACT_APP_CONTACT_SUPPORT_URL}  aria-label={t('HEADER_CONTACT_SUPPORT_PAGE')} target='_blank' rel='noreferrer'>
                            <img className='icon' aria-hidden="true" src={ HeadsetIcon } alt="" />
                            {t('HEADER_CONTACT_SUPPORT')}
                        </a>
                    </nav>
                    </div>
                    <div className='header-select-section'>
                        <ProLanguageSelect
                            label={t('HEADER_LABEL_LANGUAGE')}
                            options={langOptions}
                            onSelect={(language) => {
                                i18n.changeLanguage(language);
                            }}
                        />
                    </div>
                </div>
            </div>
            {!hiddenHeaderContent && <div className='header-wrapper'>
                <div className='header-content'>
                    <img className='header-proproctor-logo' src={Logo} alt="ProProctor logo" />
                    <h1 className='header-title'>{t('HEADER_READY_SET_TEST')}</h1>
                </div>
            </div>}
        </header>
    );
}

export default Header;
